import React, { useMemo } from "react";

import { orderBy } from "lodash";

import useGetPortfolioFamiliesById from "@fartherfinance/frontend/api/Investment/hooks/useGetPortfolioFamiliesById";
import { PortfolioFamilyId } from "@fartherfinance/frontend/api/Investment/types";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import { DropdownMenuOption } from "@src/sharedComponents/CustomDropdownBase/MenuOptionsWithCheckIfSelected/MenuOptionsWithCheckIfSelected";
import BaseDropdown from "@src/sharedComponents/Dropdown/BaseDropdown";

import {
  getPortfolioFamilyChildren,
  PortfolioFamilyChildren,
} from "./dataHelpers";

interface Props {
  portfolioFamilyId: PortfolioFamilyId | null;
  title: string;
  curItem?: string;
  onSelect: (el: DropdownMenuOption<PortfolioFamilyId>) => void;
  sorting?: (element: PortfolioFamilyChildren) => unknown; // allows us to left pad the sort order of the options to allow easy ordering of things like allocation where 1/100 should come before 10/90
  height: number;
}

const PortfolioFamilyOptions = ({
  portfolioFamilyId,
  title,
  curItem,
  onSelect,
  sorting,
  height,
}: Props) => {
  const clientAuth = useRequestAuth();
  const advisorAuth = useAdvisorRequestAuth();
  const auth = clientAuth ?? advisorAuth;

  const portfolioFamilies = useGetPortfolioFamiliesById(
    portfolioFamilyId,
    auth
  );
  const options = useMemo(
    () =>
      orderBy(
        getPortfolioFamilyChildren(portfolioFamilies),
        [(x) => (sorting === undefined ? x.label : sorting(x))],
        ["asc"]
      ),
    [portfolioFamilies, sorting]
  );

  return (
    <BaseDropdown
      title={title}
      curItemLabel={curItem}
      options={options}
      onSelect={onSelect}
      isLoading={portfolioFamilyId !== null && portfolioFamilies.isLoading}
      isDisabled={
        portfolioFamilies.isLoading || portfolioFamilyId === undefined
      }
      height={height}
    />
  );
};

export default PortfolioFamilyOptions;
